export default __webpack_public_path__ + "static/media/summary_planimages_84c.36ce334d.png";